var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectCreategradienticon = function SvgProjectCreategradienticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#project_create_gradient_icon_svg__a)",
    d: "M2.19 3.44a.31.31 0 0 0-.31.31v12.5c0 .17.13.31.3.31H7c.28 0 .5.23.5.5v.88a.5.5 0 0 1-.5.5H2.19A2.19 2.19 0 0 1 0 16.25V3.75c0-1.2.98-2.19 2.19-2.19h7.19c.68 0 1.33.33 1.74.88l1.22 1.62h5.47c1.21 0 2.19.98 2.19 2.19v10c0 1.2-.98 2.19-2.19 2.19H13a.5.5 0 0 1-.5-.5v-.88c0-.27.22-.5.5-.5h4.81c.18 0 .32-.14.32-.31v-10a.31.31 0 0 0-.32-.31h-6.15a.5.5 0 0 1-.4-.2L9.63 3.56a.31.31 0 0 0-.26-.12H2.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#project_create_gradient_icon_svg__b)",
    fillRule: "evenodd",
    d: "M9.56 7.5a.5.5 0 0 0-.5.5v3.56H5.5a.5.5 0 0 0-.5.5v.88c0 .27.22.5.5.5h3.56V17c0 .28.23.5.5.5h.88a.5.5 0 0 0 .5-.5v-3.56h3.56a.5.5 0 0 0 .5-.5v-.88a.5.5 0 0 0-.5-.5h-3.56V8a.5.5 0 0 0-.5-.5h-.88Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "project_create_gradient_icon_svg__a",
    x1: 0,
    x2: 20.15,
    y1: 1.56,
    y2: 4.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "project_create_gradient_icon_svg__b",
    x1: 5,
    x2: 15.13,
    y1: 7.5,
    y2: 8.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
};
export default SvgProjectCreategradienticon;